<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <component
      :is="visiblePopupComponent"
      v-if="visiblePopupComponent"
      :key="currentPopup"
    />
  </Transition>
</template>

<script setup lang='ts'>
import type { Component } from 'vue';
import { PopupType } from '@common/types/popups';
import DynamicPopup from '@common/components/popups/DynamicPopup.vue';
import AuthPopup from '@common/components/popups/AuthPopup.vue';
import PlayerPreviewPopup from '@common/components/popups/PlayerPreviewPopup.vue';

const { currentPopup } = usePopup();
const route = useRoute();

const popupComponents: Record<PopupType, Component> = {
  [PopupType.DYNAMIC]: DynamicPopup,
  [PopupType.AUTH]: AuthPopup,
  [PopupType.PLAYER_PREVIEW]: PlayerPreviewPopup,
};

const HIDDEN_POPUP_ROUTES = ['/team', '/rules'];

const shouldHidePopup = computed(() =>
  HIDDEN_POPUP_ROUTES.includes(route.path),
);

const currentPopupComponent = computed<Component | null>(() => {
  if (!currentPopup.value) return null;
  return popupComponents[currentPopup.value] ?? null;
});

const visiblePopupComponent = computed<Component | null>(() => {
  if (shouldHidePopup.value) return null;
  return currentPopupComponent.value;
});
</script>

<style lang='scss'>
</style>
